<div
  bsModal
  #upgradeCheckModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">Upgrade Check</h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="onCancel()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body" *ngIf="fileMetaDataList">
        Upgrade is from {{ fileMetaDataList.localVersion }} to
        {{ fileMetaDataList.cloudVersion }} is required please. This computer
        will not be able to synchronise data to or from other users until you
        complete this upgrade.

        <hr />

        <button class="btn btn-warning" (click)="onCancel()">Not now</button
        >&nbsp;
        <button class="btn btn-primary" (click)="onUpgrade()">Upgrade...</button
        >&nbsp;
      </div>
    </div>
  </div>
</div>
